jQuery(function($){
    var banner_reveal = $('.banner-section--reveal');
    if ( banner_reveal.length > 0 ) {
        banner_reveal.hover(function(){
            // Hover in
            var sticky = $(this).find('animate-sticky');
            sticky.attr('animate', '');
        },function(){
            // Hover out
            var sticky = $(this).find('animate-sticky');
            sticky.removeAttr('animate');
        });
    }
});